export interface PayType {
    id: string;
    friendlyName: string;
    price: number;
    daysDuration: number;
}

export interface InvoiceInfo {
    paymentId: string;
    walletId: string;
    status: string;
}

export type PaymentStatus = 'NEW' | 'PENDING' | 'SUCCESS' | 'INT_ERR' | 'EXT_ERR';

export const paymentStatusMapping = {
    NEW: 'Создан',
    PENDING: 'Ожидает оплаты',
    SUCCESS: 'Оплачен',
    INT_ERR: 'Ошибка',
    EXT_ERR: 'Ошибка'
}

export interface PayHistoryInfo {
    internalPaymentId: string;
    amount: number;
    status: PaymentStatus;
    createdAt: string;
}

export interface CustomerInfo {
    email: string;
}